<div id="sessionTimeoutPopup"
class="session-timeout-popup {{additionalClasses}}"
>

  <div class="topBlock">
    <div class="topText">
      Your session is about to expire
    </div>
    <div>
      <img src="../../../../../assets/images/session-timeout-image.svg" loading="lazy"/>
    </div>
    <div class="middleText">Session Timer</div>
    <div id="timer" class="timer"></div>
    <div class="botTextSession">
      Would you like to keep the session active?
    </div>
  </div>

  <div class="btnContainer a-self-center"  >
    <div id="noBtn" class="vertical-color" (click)="close()" class="sessionButton">No</div>
    <div id="yesBtn" class="vertical-color" (click)="continue()" class="sessionButton">Yes</div>
  </div>
</div>


